(function () {
  'use strict';
  if (window.AnomFunnelDiagnostics) return;
  var root;
  var seen = new Set();
  var allowed = ['view', 'config_view', 'summary_view', 'configure', 'commander_click', 'checkout_start', 'checkout_slow', 'checkout_redirect', 'checkout_error'];
  var stages = ['selection', 'cart_read', 'cart_update', 'cart_add', 'cart_verify', 'cart_change'];
  function permitted() {
    try { return window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'yes'; }
    catch (_) { return false; }
  }
  function offer() {
    return root && root.dataset.offer === 'quotidien' ? 'quotidien' : 'decouverte';
  }
  function emit(name, stage, elapsed, choice) {
    if (!root || !allowed.includes(name) || !permitted() || typeof window.clarity !== 'function') return false;
    try {
      window.clarity('set', 'anom_funnel_version', '20261021');
      window.clarity('set', 'anom_offer', offer());
      window.clarity('set', 'anom_theme_mode', window.Shopify?.theme?.role === 'main' ? 'live' : 'preview');
      window.clarity('set', 'anom_viewport', window.innerWidth < 750 ? 'mobile' : window.innerWidth < 1100 ? 'tablet' : 'desktop');
      window.clarity('set', 'anom_cart_stage', stages.includes(stage) ? stage : 'none');
      if (Number.isFinite(elapsed)) window.clarity('set', 'anom_checkout_delay', elapsed < 2000 ? 'under_2s' : elapsed < 5000 ? '2_to_5s' : 'over_5s');
      if (choice) {
        window.clarity('set', 'anom_choice_group', choice.group);
        window.clarity('set', 'anom_choice_value', choice.value);
        window.clarity('event', 'anom_' + offer() + '_choice_' + choice.group + '_' + choice.value);
      }
      window.clarity('event', 'anom_' + name);
      window.clarity('event', 'anom_' + offer() + '_' + name);
      return true;
    } catch (_) { return false; }
  }
  window.AnomFunnelDiagnostics = {emit:emit};
  function once(name) { if (!seen.has(name) && emit(name)) seen.add(name); }
  function choiceValue(button) {
    var group = button.dataset.group;
    var raw = button.dataset.label || button.dataset.weight || button.dataset.quantity || button.dataset.sizeTitle || '';
    var text = raw.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    var values = {grains:'beans', 'en grains':'beans', moulu:'ground', espresso:'espresso', filtre:'filter', piston:'french_press', italienne:'moka', aeropress:'aeropress', 'un de chaque':'mixed'};
    if (group === 'size') {
      var size = button.dataset.weight || text;
      var sizes = {'500':'500g','750':'750g','1000':'1000g','1500':'1500g','2000':'2000g','500 g':'500g','750 g':'750g','1 kg':'1000g','1,5 kg':'1500g','2 kg':'2000g',petit:'500g','petit +':'750g',moyen:'1000g',grand:'1500g'};
      return sizes[size] || 'other';
    }
    return values[text] || 'other';
  }
  function init() {
    root = document.querySelector('[data-anom-funnel]');
    if (!root) return;
    var targets = [['config_view',root.querySelector('.anom-funnel__grid')],['summary_view',root.querySelector('.js-funnel-submit')]];
    function visibleViews() {
      once('view');
      targets.forEach(function (entry) {
        if (!entry[1]) return;
        var r = entry[1].getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) once(entry[0]);
      });
    }
    visibleViews();
    if (window.IntersectionObserver) {
      var observer = new IntersectionObserver(function () { visibleViews(); },{threshold:0.1});
      targets.forEach(function (t) { if (t[1]) observer.observe(t[1]); });
    }
    document.addEventListener('visitorConsentCollected',visibleViews);
    var tries = 0;
    var timer = window.setInterval(function () {
      visibleViews();
      if (++tries >= 120 || targets.every(function (t) {return !t[1] || seen.has(t[0]);})) window.clearInterval(timer);
    },500);
    root.addEventListener('click',function (event) {
      var choice = event.target.closest('.js-funnel-choice');
      if (choice && root.contains(choice) && ['format','brew','style','size'].includes(choice.dataset.group)) {
        emit('configure',undefined,undefined,{group:choice.dataset.group,value:choiceValue(choice)});
      }
      // The mobile dock forwards to this button; count the resulting main click only.
      var submit = event.target.closest('.js-funnel-submit');
      if (submit && root.contains(submit) && !submit.disabled) emit('commander_click');
    },true);
    root.addEventListener('change',function (event) {
      var input = event.target;
      if (input.matches('input[type="radio"]') && ['relay','home'].includes(input.value)) {
        emit('configure',undefined,undefined,{group:'delivery',value:input.value});
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
